module.exports = __webpack_public_path__ + "img/snooker.243e7fa8.svg";